module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/logo-顶部导航栏.fd0d4.png";